import React, { CSSProperties, useEffect, useState } from "react";
import { Box, getColor, Icons, Typography } from "fds";
import utilsCommon from "../../../shared/utils/common";
import classNames from "classnames";
import i18n from "../../../locales/i18n";
import { t } from "i18next";
import { Policy } from "../../../types/workgroup";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import dayjs from "dayjs";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
interface WorkgroupPolicyTooltipProps {
  logItem: {
    title: string | null;
    permissionPolicy: Policy;
  }[];
  title?: string;
}

const WorkgroupPolicyTooltip: React.FC<WorkgroupPolicyTooltipProps> = ({
  logItem,
  title,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  const { workgroupState } = useWorkgroupStore();
  const targetPolicy =
    logItem[0]?.permissionPolicy?.changeCode === "DELETE" &&
    logItem[0]?.permissionPolicy?.policyType === "DOCUMENT"
      ? workgroupState.workgroupDetail?.policy?.policy
      : logItem[0]?.permissionPolicy.policy;

  const getPolicyTitle = (logItem?: {
    title: string | null;
    permissionPolicy: Policy;
  }) => {
    if (title) return title;
    if (logItem?.permissionPolicy.uniqueId === "MASTER")
      return t("log.logTitle.master");
    else if (
      logItem?.permissionPolicy?.changeCode === "DELETE" &&
      logItem?.permissionPolicy?.policyType === "DOCUMENT"
    )
      return t("log.logTitle.workgroup");
    else if (logItem?.permissionPolicy.authType === "DENY")
      return t("log.logTitle.deny");
    else if (logItem?.permissionPolicy.targetType === "USER")
      return t("log.logTitle.ind");
    else return t("log.logTitle.allMember");
  };
  return (
    <Box direction="column" classes="workgroupFilePolicy">
      <Box alignItems={"center"}>
        <Icons
          variant="fill"
          label="dot"
          stroke={
            logItem[0]?.permissionPolicy.uniqueId === "MASTER"
              ? "green"
              : logItem[0]?.permissionPolicy?.changeCode === "DELETE" &&
                logItem[0]?.permissionPolicy?.policyType === "DOCUMENT"
              ? getColor("COLOR_BG_SUCCESS")
              : logItem[0]?.permissionPolicy.authType === "DENY"
              ? "gray"
              : logItem[0]?.permissionPolicy.targetType === "USER"
              ? "orange"
              : getColor("COLOR_BG_SUCCESS")
          }
        />
        <Typography type="subtitle3" exactColor={"white"} classes={"mg ml-4"}>
          {getPolicyTitle(logItem[0])}
        </Typography>
      </Box>
      {logItem[0]?.title &&
        !(
          logItem[0]?.permissionPolicy?.changeCode === "CREATE" &&
          logItem[0]?.permissionPolicy?.policyType === "DOCUMENT" &&
          logItem[0]?.permissionPolicy.targetType === "WORKGROUP"
        ) && (
          <Typography
            exactColor="white"
            type="body4_rg"
            lineHeight="18px"
            classes="mg mt-6"
            textAlign="start"
            maxWidth={330}
          >
            {logItem.map((item) => item.title).join(", ")}
          </Typography>
        )}
      {(logItem[0]?.permissionPolicy.authType !== "DENY" ||
        (logItem[0]?.permissionPolicy?.changeCode === "DELETE" &&
          logItem[0]?.permissionPolicy?.policyType === "DOCUMENT")) &&
        targetPolicy &&
        logItem.length === 1 && (
          <Box direction="column" classes="mg mt-4" alignItems="start">
            {targetPolicy.revision && (
              <Typography exactColor="white" type="body4_rg">
                · {t("log.filterDocument.1")}
              </Typography>
            )}
            {targetPolicy.download && (
              <Typography exactColor="white" type="body4_rg">
                · {t("log.filterDocument.5")}
              </Typography>
            )}
            {targetPolicy.wrapping &&
            targetPolicy.drmPerm &&
            targetPolicy.drmPerm?.length === 0 ? (
              <Box alignItems="center">
                <Typography exactColor="white" type="body4_rg">
                  · {t("log.settingNormal")}
                  {`(${t("common.allow")}: ${t("file.policy.print")},${t(
                    "file.policy.printScreen"
                  )},${t("file.policy.copyDoc")})`}
                </Typography>
              </Box>
            ) : targetPolicy.wrapping &&
              targetPolicy?.drmPerm &&
              targetPolicy.drmPerm?.length > 0 ? (
              <Box alignItems="center">
                <Typography
                  exactColor="white"
                  type="body4_rg"
                  wordBreak="break-word"
                  textAlign="start"
                >
                  · {t("log.settingAdvanced")}
                  {i18n.language !== "ko" && " "}
                  {targetPolicy?.drmPerm?.length < 4 &&
                    `(${t("file.policy.noAllow")} ${[
                      "print",
                      "print_screen",
                      "extract",
                    ]
                      .filter((item) => !targetPolicy?.drmPerm?.includes(item))
                      .map((item1) => {
                        return item1 === "print"
                          ? t("file.policy.print")
                          : item1 === "print_screen"
                          ? t("file.policy.printScreen")
                          : item1 === "extract"
                          ? t("file.policy.copyDoc")
                          : "";
                      })
                      .join(", ")})`}
                </Typography>
              </Box>
            ) : (
              ""
            )}
            {targetPolicy.allowDays > 0 && (
              <Typography exactColor="white" type="body4_rg">
                · {t("file.policy.allowPeriod")}:{" "}
                {logItem[0]?.title &&
                logItem[0]?.permissionPolicy.changeCode !== "DELETE"
                  ? dayjs(targetPolicy.startTime)
                      .add(targetPolicy.allowDays - 1, "day")
                      .format(
                        i18n.language.includes("ar")
                          ? "DD/MM/YYYY"
                          : "YYYY-MM-DD"
                      )
                  : targetPolicy.allowDays - 1 + t("common.days")}
                {" GMT+" + targetPolicy.allowDaysTimeZone}
              </Typography>
            )}
            {targetPolicy.allowViewCount > 0 && (
              <Typography exactColor="white" type="body4_rg">
                · {t("file.policy.remainCount")}:{" "}
                {targetPolicy.allowViewCount - targetPolicy.currentViewCount <=
                0
                  ? 0
                  : targetPolicy.allowViewCount - targetPolicy.currentViewCount}
                /{targetPolicy.allowViewCount}
              </Typography>
            )}
            {utilsCommon.checkSupportPolicy("Web") === "SUPPORT_ACCEPTED" &&
              targetPolicy.webView && (
                <Box alignItems="center">
                  <Typography exactColor="white" type="body4_rg">
                    · {t("file.policy.webSupport")}
                  </Typography>
                  {loginDto.ecoCommonConfig.watermark !== "NONE" && (
                    <Typography
                      exactColor="white"
                      type="body4_rg"
                      classes={classNames({
                        "mg ml-4": i18n.language !== "ko",
                      })}
                    >
                      ({t("file.policy.screenWatermark")})
                    </Typography>
                  )}
                </Box>
              )}
            {utilsCommon.checkSupportPolicy("Mobile") ===
              "SUPPORT_ACCEPTED" && (
              <Typography exactColor="white" type="body4_rg">
                · {t("file.policy.mobileSupport")}
              </Typography>
            )}
            {utilsCommon.checkSupportPolicy("Mac") === "SUPPORT_ACCEPTED" && (
              <Typography exactColor="white" type="body4_rg">
                · {t("file.policy.macSupport")}
              </Typography>
            )}
          </Box>
        )}
    </Box>
  );
};
export default WorkgroupPolicyTooltip;
